import { DOCUMENT } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { CUSTOM_ELEMENTS_SCHEMA, DoBootstrap, Inject, Injector, NgModule } from '@angular/core'
import { createCustomElement } from '@angular/elements'
import { ReactiveFormsModule } from '@angular/forms'
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio'
import { BrowserModule } from '@angular/platform-browser'

import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { environment } from 'src/environments/environment'

// import { AppComponent } from './app.component'
import { AddVetComponent } from './lib/add-vet/add-vet.component'
import { CelebrationComponent } from './lib/add-vet/celebration/celebration.component'
import { OtherNamesComponent } from './lib/add-vet/other-names/other-names.component'
import { OtherOwnersComponent } from './lib/add-vet/other-owners/other-owners.component'
import { VetClinicComponent } from './lib/add-vet/vet-clinic/vet-clinic.component'
import { CurrentVetsComponent } from './lib/current-vets/current-vets.component'
import { EditVetComponent } from './lib/edit-vet/edit-vet.component'
import { MyvetsNotificationComponent } from './lib/myvets-notification/myvets-notification.component'
import { NewVetComponent } from './lib/new-vet/new-vet.component'
import { BackButtonModule } from './molecules/back-button/back-button.module'
import { CancelButtonModule } from './molecules/cancel-button/cancel-button.module'
import { StepperModule } from './molecules/stepper/stepper.module'
import { MaterialModule } from './shared/material.module'
import { SharedModule } from './shared/shared.module'

@NgModule({
	declarations: [
		// AppComponent,
		AddVetComponent,
		EditVetComponent,
		CurrentVetsComponent,
		VetClinicComponent,
		OtherOwnersComponent,
		OtherNamesComponent,
		CelebrationComponent,
		MyvetsNotificationComponent,
		NewVetComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		ReactiveFormsModule,
		SharedModule,
		MaterialModule,
		BackButtonModule,
		CancelButtonModule,
		StepperModule,
	],
	// exports: [EditVetModule, AddVetModule, CurrentVetsModule],
	providers: [{ provide: MAT_RADIO_DEFAULT_OPTIONS, useValue: { color: 'primary' } }],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule implements DoBootstrap {
	constructor(@Inject(DOCUMENT) private readonly document: Document, private readonly injector: Injector) {
		const AddVetElement = createCustomElement(AddVetComponent, { injector: this.injector })
		const EditVetElement = createCustomElement(EditVetComponent, { injector: this.injector })
		const CurrentVetsElement = createCustomElement(CurrentVetsComponent, { injector: this.injector })
		const VetsNotificaitonElement = createCustomElement(MyvetsNotificationComponent, { injector: this.injector })

		customElements.define('emb-add-vet', AddVetElement)
		customElements.define('emb-edit-vet', EditVetElement)
		customElements.define('emb-current-vets', CurrentVetsElement)
		customElements.define('emb-myvets-notification', VetsNotificaitonElement)

		// adds environment specific palette.css file from CDN
		const head = this.document.getElementsByTagName('head')[0]
		const styeLinkElement = this.document.getElementById(
			'environment-style'
		) as HTMLLinkElement
		if (styeLinkElement) {
			styeLinkElement.href = environment.cdnStyleLink
		} else {
			const style = this.document.createElement('link')
			style.id = 'environment-style'
			style.rel = 'stylesheet'
			style.href = environment.cdnStyleLink

			head.appendChild(style)
		}
	}
	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngDoBootstrap(): void {}
}
